import Vue from 'vue'
import { MutationTree } from 'vuex/types/index'
import { ApplicationSubmissionsState, ApplicationSubmissionResource } from './submissions.types'

const mutations: MutationTree<ApplicationSubmissionsState> = {
  SET_SUBMISSION (state, submission: ApplicationSubmissionResource) {
    Vue.set(state.data, submission.id, submission)
  }
}

export default mutations

